import { useEffect } from "react";
import { connect } from "react-redux";

import * as actions from "../../store/actions/index";
import { withRouter } from "../../shared/utility";
import { formatDateWithTime } from "../../shared/utility";

import { CampaignUsersViewModel } from "../../viewmodels/campaigns/CampaignUsersViewModel";
import EmptyModal from "../../components/modals/EmptyModal";
import SlideOver from "../../components/slideOver/SlideOver";
import LoadingSvg from "../../components/spinners/LoadingSvg";

function CampaignUsers(props) {
  const { logout, addSnackbar } = props;
  const {
    askDeleteCampaignUser,
    campaignUsers,
    emptyModal,
    getCampaignUsers,
    loading,
    openAddCampaignUserSlideOver,
    openEditCampaignUserSlideOver,
    setEmptyModelOpen,
    setSlideOver,
    slideOver,
  } = CampaignUsersViewModel(logout, addSnackbar);

  useEffect(() => {
    getCampaignUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className="mt-2">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="sm:flex sm:items-center px-4 py-5 sm:px-4 card-custom">
            <div className="sm:flex-auto sm:flex sm:items-center sm:justify-between">
              <h1 className="text-base font-semibold leading-6 text-gray-900">
                Campaign Users
              </h1>
              <div className="mt-5 sm:mt-0 flex justify-end">
                <button
                  type="button"
                  className="rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  onClick={openAddCampaignUserSlideOver}
                >
                  Add Campaign User
                </button>
              </div>
            </div>
          </div>
          <div className="mt-8 flow-root">
            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                {loading ? (
                  <div className="border h-10 shadow rounded-md p-4 w-full mx-auto flex items-center">
                    <LoadingSvg />
                    <span className="text-gray-600">Loading</span>
                  </div>
                ) : (
                  <div className="overflow-hidden card-custom">
                    <table className="min-w-full divide-y divide-gray-300">
                      <thead className="bg-white">
                        <tr>
                          <th
                            scope="col"
                            className="py-3 pl-3 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                          >
                            Name
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                          >
                            PIN
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                          >
                            Created At
                          </th>
                          <th
                            scope="col"
                            className="relative py-3.5 pl-3 pr-4 sm:pr-6"
                          ></th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200 bg-white">
                        {(!campaignUsers.data ||
                          campaignUsers.data.length === 0) ? (
                          <tr>
                            <td
                              colSpan={4}
                              className="px-4 py-8 text-center text-gray-500 text-sm"
                            >
                              No campaign users yet
                            </td>
                          </tr>
                        ) : (
                          campaignUsers.data.map((user) => (
                            <tr key={user.id}>
                              <td className="whitespace-nowrap py-1.5 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                {user.name}
                              </td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                {user.pin ?? ""}
                              </td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                {user.created_at
                                  ? formatDateWithTime(user.created_at)
                                  : "N/A"}
                              </td>
                              <td className="relative whitespace-nowrap py-1.5 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                <button
                                  onClick={() =>
                                    openEditCampaignUserSlideOver(user)
                                  }
                                  className="rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                >
                                  Edit
                                </button>
                                <button
                                  onClick={() =>
                                    askDeleteCampaignUser(user)
                                  }
                                  className="ml-2 rounded-md bg-red-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                                >
                                  Delete
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
          <EmptyModal
            childComponent={emptyModal.childComponent}
            open={emptyModal.open}
            setOpen={setEmptyModelOpen}
          />
          <SlideOver
            childComponent={slideOver.childComponent}
            slideOver={slideOver}
            setSlideOver={setSlideOver}
          />
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(actions.logout()),
  addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CampaignUsers),
);
